import MembershipPaymentMethod from './MembershipPaymentMethod';

export default MembershipPaymentMethod;
